import React from 'react'
import { Button } from 'primereact/button';
import { useContext, useState } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../../../Context/AuthContext/AuthContext';
import { ConfigContext } from '../../../../Context/ConfigContext/ConfigContext';


//*****************************************Componentes Generales************************************************************ */
import Card from '../../../../Components/Card/Card';
import AgGrid from '../../../../Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../Components/Loader/Loader'
import CalendarioOperativo from '../../../../Components/CalendarioOperativo/CalendarioOperativo';
import CalendarioMensual from '../../../../Components/CalendarioMensual/CalendarioMensual'
import ModalCuentasPorPagarCompras from '../ModalCXP/ModalCuentasPorPagarCompras'
//**************************************************Consultas API************************************************ */
import { getFechasComprasFacturasManuales, getFechasFacturasManuales, getFechasFacturasMateriaPrima } from '../../../../API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import { Tag } from 'primereact/tag';
import { getDateProduction } from '../../../../Services/FechasService';
import { CuentasPorPagarLang } from '../Lang/CuentasPorPagarLang';
import { getLabel } from '../../../../Services/Language/LanguageService';
const RegistroFacturasScreen = ({isMateriaPrima = false}) => {
    const [loading, setLoading] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()])
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [dialogCuentas, setDialogCuentas] = useState(false);
    const [IdFactura, setIdFactura] = useState(0);

    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);

    const obtenerInformacion = async () => {
        setLoading(true)
        // const result = await getFechasFacturasManuales(getDateProduction(dates));
        let result = []
        if(!isMateriaPrima){
            result = await getFechasComprasFacturasManuales(getDateProduction(dates));
        }else{
            result = await getFechasFacturasMateriaPrima(getDateProduction(dates))
        }
        setData(result)
        setSelected([])
        setLoading(false)
    }

    const OpenModal = (rowData) => {
        if (rowData) {
            setIdFactura(rowData?.Id)
        }
        setDialogCuentas(true)
    }



    const hideDialog = () => {
        setIdFactura(null)
        setDialogCuentas(false)
        obtenerInformacion()
    }

    const EstadoTemplate = (rowData) => {
        switch (rowData.IdEstadoFinanzas) {
            case 3581:
                return <Tag style={{ width: 100, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3580:
                return <Tag style={{ width: 100, backgroundColor: "rgb(227, 63, 63)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3607:
                return <Tag style={{ width: 100, backgroundColor: "rgb(217, 206, 41)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3713:
                return <Tag style={{ width: 100, backgroundColor: "rgb(63, 142, 227)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3714:
                return <Tag style={{ width: 100, backgroundColor: "rgba(0, 191, 57, 0.75)" }} value={rowData.EstadoFinanzas} />
                break;

            default:
                return <div><span>{rowData.EstadoFinanzas}</span></div>
                break;
        }
    }

    const DiasVencidos = (DiasVencidos) => {
        if (DiasVencidos < 0) {
            return (
                <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex'>{DiasVencidos}</span>
            )
        } else {
            return (
                <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex' >{DiasVencidos}</span>
            )
        }
    }


    const table = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'Id',
                header: 'Id',
                headerEn: '',
                className: 'XXsmall',
                frozen: true,
                hidden: userAuth.rol !== 1
            },

            {
                field: 'IncomeDate',
                header: 'Fecha Factura',
                headerEn: 'IncomeDate',
                className: 'small',
                Format: 'Date',
                frozen: true,
                alignFrozen: 'left',
                sort: 'desc'
            },
            {
                field: 'NoIngreso',
                header: 'No Ingreso',
                headerEn: 'No Ingreso',
                className: 'small',
                Format: 'Center',
                onCellDoubleClicked: ({ data }) => {
                    if (data.Id) {
                        OpenModal(data)
                    }
                },
                frozen: true,
                alignFrozen: 'left',
                Sumary: 'count'
            },
            {
                field: 'Documento',
                header: 'Documento',
                headerEn: 'Document',
                className: '',
                onCellDoubleClicked: ({ data }) => {
                    if (data.Id) {
                        OpenModal(data)
                    }
                },
                frozen: true,
                alignFrozen: 'left',
                Sumary: 'count'
            },
            {
                field: 'PurchaseOrder',
                header: 'PO',
                headerEn: '',
                className: 'small',
                Format: 'Center',
                frozen: true,
                alignFrozen: 'left',
                // onCellDoubleClicked: ({ data }) => {

                //     if (data.PurchaseOrder) {
                //         window.open(`${process.env.REACT_APP_ENV}/OrdenesCompra/${data.PurchaseOrder}`, data.PurchaseOrder, 'height=800,width=1450')
                //     }
                // }
            },

            {
                field: 'EstadoFinanzas',
                header: 'Estado Finanzas',
                headerEn: 'Finance Status',
                className: 'small',
                // Format: "Template",
                // body: (rowData) => EstadoTemplate(rowData),
                Format: 'Estado',
                body: (rowData) => ({
                    ID: rowData?.IdEstadoFinanzas,
                    Estado: rowData?.EstadoFinanzas
                }),
            },
            {
                field: 'CustomerName',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'XXlarge',
            },

            {
                field: 'TermName',
                header: 'TermName',
                headerEn: 'TermName',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'OCE',
                header: 'OCE',
                headerEn: 'OCE',
                className: 'small',
            },
            {
                field: 'FechaDocumento',
                header: 'Fecha Documento',
                headerEn: 'Document Date',
                className: 'medium',
                Format: 'Date',
            },
            // {
            //     field: 'Memo',
            //     header: 'Memo',
            //     headerEn: '',
            //     className: 'XXlarge',
            // },

            {
                field: 'Comentario',
                header: 'Comentario',
                headerEn: 'Comment',
                className: 'XXlarge',
            },
          
            {
                field: 'NombreReferencia',
                header: 'Referencia',
                headerEn: 'Reference',
                className: 'medium',
                Format: 'Center'
            },

            {
                field: 'FechaVencido',
                header: 'Fecha Vencido',
                headerEn: 'Expired Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'DiasVencidos',
                header: 'Dias Vencidos',
                headerEn: 'Expired Days',
                className: 'Xsmall',
                Format: 'Template',
                body: rowData => DiasVencidos(rowData.DiasVencidos)
            },
            {
                field: 'PersonaIngreso',
                header: 'Ingresado por',
                headerEn: 'Income',
                className: '',
            },

            {
                field: 'CostoL',
                header: 'Costo L',
                headerEn: 'Cost L',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
                editable: userAuth.IdRol === 1,
                hidden: userAuth.IdRol === 1,
            },
            {
                field: 'CostoD',
                header: 'Costo $',
                headerEn: 'Cost $',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
                editable: userAuth.IdRol === 1,
                hidden: userAuth.IdRol === 1,
            },
            {
                field: 'MontoL',
                header: 'Monto L',
                headerEn: 'Amount L',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right',
                editable: userAuth.IdRol === 1,
            },
            {
                field: 'MontoD',
                header: 'Monto $',
                headerEn: 'Amount $',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right'
            },
            // {
            //     field: 'UserIngresoCompras',
            //     header: 'Usuario Ingreso',
            //     headerEn: 'Income User',
            //     className: 'small',
            // },

            {
                field: 'Id',
                header: '',
                Format: 'Botones',
                Botones: [
                    {
                        icon: 'pi pi-pencil',
                        tooltip: 'Editar',
                        onClick: (rowData) => {
                            OpenModal(rowData)
                        }
                    },
                ],
                frozen: true,
                alignFrozen: 'right'
            },
            // {
            //     field: 'Id',
            //     header: '',
            //     Format: 'Botones',
            //     hidden: userAuth.IdRol === 1,
            //     Botones: [
            //         {
            //             icon: 'pi pi-times',
            //             tooltip: 'Eliminar CXP',
            //             className: 'text-danger',
            //             onClick: (rowData) => {
            //                 let s = selected?.length === 0 ? [rowData] : selected
            //                 // EliminarCXP(s)

            //             },

            //         },
            //     ],
            //     frozen: true,
            //     alignFrozen: 'right'
            // }
        ]

    }


    return (
        <div>

            <ConfirmDialog />
            <Loader loading={loading} querySelector='#CXPEnc' />
            <Card
                titulo={<div className='d-flex flex-row'>
                    <CalendarioMensual
                        getInfo={!isMateriaPrima? getFechasComprasFacturasManuales: getFechasFacturasMateriaPrima}
                        data={data}
                        setData={setData}
                        dates={dates}
                        setDates={setDates}
                        selected={selected}
                        setSelected={setSelected}
                        loading={loading}
                        setLoading={setLoading}
                    />

                    <Button icon='pi pi-plus' onClick={() => OpenModal(null)} className='mx-2'
                        style={{ height: 35, marginTop: 2 }} tooltip={getLabel(CuentasPorPagarLang, 'tooltipNuevo', config?.language)} />
                </div>}

                contenido={<div className='pt-4' style={{ height: '85vh' }} id='CXPEnc'>
                    <AgGrid table={table} />
                </div>}
            />
            <ModalCuentasPorPagarCompras
                dialogCuentas={dialogCuentas}
                hideDialog={hideDialog}
                IdFactura={IdFactura}
            />

        </div>
    )
}

export default RegistroFacturasScreen


